import 'reflect-metadata';
import { asEntity, Convertible } from '../Commons';
import { FundEntity } from './Fund.Entity';
import { BaseEntity } from './index.exports';

@asEntity()
export class HistoryDeposit extends BaseEntity {
    protected static _apiRoute: string = 'history-deposits';
    protected static _className: string = 'History Deposit';

    // #region fields

    @Convertible({ type: String, propertyToFill: 'fund', relation: 'ManyToOne', typeRelation: FundEntity, cascadeSave: true, cascadeLoad: false })
    fund_id!: string;
    fund!: FundEntity | undefined;

    @Convertible({})
    date!: Date;

    @Convertible({})
    monthsRemaining!: number;

    @Convertible({})
    newDeposits!: bigint;

    @Convertible({})
    newCommissions!: bigint;

    @Convertible({})
    totalDeposits!: bigint;

    @Convertible({})
    totalCommissions!: bigint;

    @Convertible({})
    totalCommissions_Release_PerMonth_1e6!: bigint;

    @Convertible({})
    newCommissions_Collected_Protocol!: bigint;

    @Convertible({})
    newCommissions_Collected_Managers!: bigint;

    @Convertible({})
    newCommissions_Collected_Delegators!: bigint;

    @Convertible({})
    totalCommissions_Collected_Protocol!: bigint;

    @Convertible({})
    totalCommissions_Collected_Managers!: bigint;

    @Convertible({})
    totalCommissions_Collected_Delegators!: bigint;
  
    @Convertible({})
    newAvailableCommissions_Protocol!: bigint;

    @Convertible({})
    newAvailableCommissions_Managers!: bigint;

    @Convertible({})
    newAvailableCommissions_Delegators!: bigint;

    @Convertible({})
    totalAvailableCommissions_Protocol!: bigint;

    @Convertible({})
    totalAvailableCommissions_Managers!: bigint;

    @Convertible({})
    totalAvailableCommissions_Delegators!: bigint;

    @Convertible({ isCreatedAt: true })
    createdAt!: Date;

    @Convertible({ isUpdatedAt: true })
    updatedAt!: Date;

    // #endregion fields

    // #region  db

    public static defaultFieldsWhenUndefined: Record<string, boolean> = {};

    public static alwaysFieldsForSelect: Record<string, boolean> = {
        ...super.alwaysFieldsForSelect,
        fund_id: true,
        date: true,
        monthsRemaining: true,
        newDeposits: true,
        newCommissions: true,
        totalDeposits: true,
        totalCommissions: true,
        totalCommissions_Release_PerMonth_1e6: true,
        newCommissions_Collected_Protocol: true,
        newCommissions_Collected_Managers: true,
        newCommissions_Collected_Delegators: true,
        totalCommissions_Collected_Protocol: true,
        totalCommissions_Collected_Managers: true,
        totalCommissions_Collected_Delegators: true,
        newAvailableCommissions_Protocol: true,
        newAvailableCommissions_Managers: true,
        newAvailableCommissions_Delegators: true,
        totalAvailableCommissions_Protocol: true,
        totalAvailableCommissions_Managers: true,
        totalAvailableCommissions_Delegators: true,
    };

    // #endregion  db

    // #region class methods

    public show(): string {
        return `[${this.date} - ${this.fund_id}] Deposits: ${this.newDeposits} - Commissions: ${this.newCommissions} - Total Deposits: ${this.totalDeposits} - Total Commissions: ${this.totalCommissions}}`;
    }

    // #endregion class methods
}
